import digitalImg1 from "../../assets/img/dp1.png";
import digitalImg2 from "../../assets/img/dp2.png";
import digitalImg3 from "../../assets/img/dp3.png";
import digitalImg4 from "../../assets/img/dp4.png";
import digitalImg5 from "../../assets/img/dp5.png";
import digitalImg6 from "../../assets/img/dp6.png";

    export const digitalLinks = [
      {
        title: "Konica Direct Image Printer (DI)",
        description: "Bridging between electronic prepress systems and true offset printing. Allows digital data to be sent directly to the printing press using direct-to-press, non-photographic technology. No more film or chemistry!",
        imgUrl: digitalImg1,
      },
      {
        title: "6Ft/10Ft Large Format Printer",
        description: "Eco Solvent Dx5 XP600 4720 Printer for Flex Banners, SAV, Windows Graphics, and Transparent Stickers. Speed 15m2/Hour; Interface USB2.0",
        imgUrl: digitalImg2,
      },
      {
        title: "24-inchs Plotter Printer",
        description: "VEVOR Vinyl Cutter Machine, 720mm Cutting Plotter, Automatic Camera Contour Cutting 28 Plotter Printer with Floor Stand Vinyl Cutting Machine Adjustable Force and Speed for Sign Making Plotter Cutter",
        imgUrl: digitalImg3,
      },
      {
        title: "15/15-inchs Heat Press",
        description: "5 in 1 Digital Multifunctional Sublimation Heat Press Machine for T-Shirts, Hat, Mug, Face-Cap and Plate",
        imgUrl: digitalImg4,
      },
      {
        title: "Single Head 1501C Monogram Machine",
        description: "Ultimate Branding Machine: Embroidery Area 22x14 inches, 15 Needles/Colours, 28 Keyboard Fonts, Speed 1200 SPM, Real-time Stitching Preview, and Thread Break Detection",
        imgUrl: digitalImg5,
      },
      {
        title: "Textile & Dye - Sublimation Printer",
        description: "Texart XT-640 Direct-To-Garment (DTG) Printer. Print on a range of fabric products and sizes at once; bags, cotton blankets, fashion accessories etc",
        imgUrl: digitalImg6,
      },
    ];

